import { computed, onMounted, onUnmounted, watch } from 'vue'
import router from '@/router'
import { useRoute } from 'vue-router'
import { HistoryQueryStringType } from '@/enums/queryString'

export const useHistory = (type: HistoryQueryStringType, closeCallback: Function) => {
  const route = useRoute()
  const currentPath = computed(() => router.currentRoute.value.path)

  // global.scss 에서 modal, dialog 오픈시 백그라운드 스타일 처리를 위함
  const handleAddElement = (show: boolean) => {
    window.document.documentElement.classList[show ? 'add' : 'remove'](type)
  }

  watch(
    () => route.query,
    (params) => {
      if (!params[HistoryQueryStringType.PANEL] || !params[HistoryQueryStringType.FULLSCREEN_POPUP]) {
        closeCallback()
      }
    },
    { deep: true }
  )

  onMounted(() => {
    history.pushState(null, document.title, `${currentPath.value}?${type}=open`)
    handleAddElement(true)
  })
  onUnmounted(() => {
    closeCallback()
    history.replaceState(null, document.title, currentPath.value)
    handleAddElement(false)
  })
}
